// extracted by mini-css-extract-plugin
module.exports = {"directConnection":"DirectConnection_directConnection__zNWXF"};